
import * as BABYLON from '@babylonjs/core';
import { Scene, Engine, ArcRotateCamera } from '@babylonjs/core';
import { SceneConfiguration } from '@/models/sceneConfiguration.ts';
import store from '@/store';

export class ScreenMaker {
  private _action: (x: string) => void;

  constructor(action: (x: string) => void) {
    this._action = action;
  }

  public preparePanel(
    scene: Scene,
    engine: Engine,
    sceneConfiguration: SceneConfiguration,
    size: any,
    center: boolean = false,
  ) {
    if (scene != null && engine != null) {
      this.prepareSceneScreen(engine, scene, sceneConfiguration, size, center);
    } else {
      this.prepareScreenSceneCallback();
    }
  }

  public preparePackshots(
    engine: BABYLON.Engine,
    scene: BABYLON.Scene,
    sceneConfiguration: SceneConfiguration,
    size: any,
    center: boolean,
    callback: (main: string, inner: string, back: string) => void,
  ) {
    const camera = scene.cameras[0] as ArcRotateCamera;
    const currentPosition = camera.position.clone();
    const currentRadius = camera.radius;
    const areFrontsVisible = store.getters.scene.areFrontsVisible;
    if (center) {
      sceneConfiguration.centerCamera();
    }
    let main = '';
    let inner = '';
    let back = '';
    store.commit('setFrontsVisibility', true);
    BABYLON.Tools.CreateScreenshotUsingRenderTarget(
      engine,
      camera,
      size,
      (data) => {
        main = data;
      },
    );
    store.commit('setFrontsVisibility', false);
    BABYLON.Tools.CreateScreenshotUsingRenderTarget(
      engine,
      camera,
      size,
      (data) => {
        inner = data;
      },
    );
    camera.alpha = camera.alpha + Math.PI;
    store.commit('setFrontsVisibility', true);
    BABYLON.Tools.CreateScreenshotUsingRenderTarget(
      engine,
      camera,
      size,
      (data) => {
        back = data;
      },
    );
    camera.position = currentPosition;
    camera.radius = currentRadius;
    store.commit('setFrontsVisibility', areFrontsVisible);
    callback(main, inner, back);
  }

  private prepareSceneScreen(
    engine: BABYLON.Engine,
    scene: BABYLON.Scene,
    sceneConfiguration: SceneConfiguration,
    size: any,
    center: boolean,
  ) {
    const camera = scene.cameras[0];
    if (camera) {
      const currentPosition = camera.position.clone();
      if (center) {
        sceneConfiguration.centerCamera();
      }
      BABYLON.Tools.CreateScreenshotUsingRenderTarget(
        engine,
        camera,
        size,
        (data) => {
          camera.position = currentPosition;
          this.prepareScreenSceneCallback(data);
        },
      );
    } else {
      this.prepareScreenSceneCallback();
    }
  }

  private prepareScreenSceneCallback(x: string = '') {
    this._action(x);
  }
}
